export interface IForceChangePasswordErrorKeys {
  titleKey: string
  descriptionKey: string
}

/**
 * Maps a Cognito exception name (from `error.name`) to the i18n keys used by
 * the force-change-password notification. The modal stays open after every
 * error so the user can retry; only the copy varies.
 */
export function getForceChangePasswordErrorKeys(cognitoExceptionName: string): IForceChangePasswordErrorKeys {
  switch (cognitoExceptionName) {
    case 'InvalidPasswordException':
      return {
        titleKey: 'error.invalidPasswordException',
        descriptionKey: 'error.invalidPasswordExceptionMessage',
      }

    case 'LimitExceededException':
    case 'TooManyRequestsException':
    case 'TooManyFailedAttemptsException':
      return {
        titleKey: 'error.limitExceededException',
        descriptionKey: 'error.limitExceededExceptionMessage',
      }

    case 'NotAuthorizedException':
      return {
        titleKey: 'error.forceChangePassword.sessionExpired',
        descriptionKey: 'error.forceChangePassword.sessionExpiredMessage',
      }

    case 'NetworkError':
      return {
        titleKey: 'error.networkError',
        descriptionKey: 'error.networkErrorMessage',
      }

    default:
      return {
        titleKey: 'error.generic',
        descriptionKey: 'error.generic.description',
      }
  }
}
